import { gql } from '@apollo/client'
import { useSafeRunMutation } from 'utils/mutations'

// BENEFIT_INQUIRY_UPDATE_ATTACHMENT

const mutation = gql`
  mutation benefitInquiryUpdateAttachment(
    $id: ID!
    $attachment: BenefitInquiryUpdateAttachmentInput!
  ) {
    benefitInquiryUpdateAttachment(id: $id, attachment: $attachment) {
      id
      form_attachment {
        id
        title
        notes
      }
    }
  }
`
export default function useBenefitInquiryUpdateAttachment() {
  const { onMutate: onBenefitInquiryAttachmentUpdate, loading } =
    useSafeRunMutation({
      mutation,
      responsePath: 'benefitInquiryUpdateAttachment',
      successMessage: 'Attachment updated'
    })

  return { onBenefitInquiryAttachmentUpdate, loading }
}
